import { render, staticRenderFns } from "./DonatorDetails.vue?vue&type=template&id=de61c216&"
import script from "./DonatorDetails.vue?vue&type=script&lang=js&"
export * from "./DonatorDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports